var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('contribute-form');
import { breakpoints, theme } from '@shapeable/theme';
import { ErrorList } from '../elements/error-list';
import { Field } from '../elements/field';
import { FormButton } from '../elements/form-button';
import { FormLoader } from '../elements/form-loader';
import { Input } from '../elements/input';
import { onSubmitNetlifyForm } from '../../utils/on-submit-netlify-form';
import { Select } from '../elements/select';
import { TextArea } from '../elements/text-area';
import { usePage } from '../../hooks/use-page';
import { useContributeForm } from '../../hooks/use-contribute-form';
import { useLinearNavigation } from '../../hooks/use-linear-navigation';
import EmailValidator from 'email-validator';
import { filter, includes, trim, without } from 'lodash';
import ReCAPTCHA from 'react-google-recaptcha';
import validUrl from 'valid-url';
import { useSiteRecaptchaKey } from '../../hooks/use-site-recaptcha-key';
export var ContributeFormDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-height: 200px;\n  "], ["\n    min-height: 200px;\n  "])))
});
var FieldStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SelectStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n    font-size: ", ";\n  "], ["\n    width: 100%;\n    font-size: ", ";\n  "])), theme.FONT_SIZE(14))
});
var FormStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme.UNIT(3))
});
var TextAreaStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    width: 100%;\n    height: 150px;\n    color: ", ";\n  "], ["\n    width: 100%;\n    height: 150px;\n    color: ", ";\n  "])), theme.COLOR('dark'))
});
var InputStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    width: 100%;\n    color: ", ";\n  "], ["\n    width: 100%;\n    color: ", ";\n  "])), theme.COLOR('dark'))
});
var SubmitButtonStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 100%;\n    margin-top: ", ";\n  "], ["\n    width: 100%;\n    margin-top: ", ";\n  "])), theme.UNIT(2))
});
var OverlayStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    z-index: 100;\n    box-sizing: border-box;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n  "], ["\n    z-index: 100;\n    box-sizing: border-box;\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n  "])))
});
var LoaderStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), OverlayStyles)
});
var ThankyouStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    ", ";\n    background: rgba(0,0,0,0.9);\n    padding: ", ";\n    width: 100%;\n    flex-grow: 1;\n    color: ", ";\n    font-weight: 400;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: column;\n    text-align: center;\n    p {\n      margin: ", ";\n    }\n  "], ["\n    ", ";\n    background: rgba(0,0,0,0.9);\n    padding: ", ";\n    width: 100%;\n    flex-grow: 1;\n    color: ", ";\n    font-weight: 400;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: column;\n    text-align: center;\n    p {\n      margin: ", ";\n    }\n  "])), OverlayStyles, theme.UNIT(4), theme.COLOR('light'), theme.UNIT(4))
});
var ThankyouMessageStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    height: 200px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n    font-size: 1.25em;\n  "], ["\n    height: 200px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n    font-size: 1.25em;\n  "])))
});
var DoneButtonStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", ";\n    \n  "], ["\n    ", ";\n    \n  "])), SubmitButtonStyles)
});
var ErrorsStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    color: ", ";\n    background: #EFEEEE;\n    padding: ", ";\n    margin-bottom: ", ";\n    font-weight: 500;\n    font-size: ", ";\n  "], ["\n    color: ", ";\n    background: #EFEEEE;\n    padding: ", ";\n    margin-bottom: ", ";\n    font-weight: 500;\n    font-size: ", ";\n  "])), theme.COLOR('red'), theme.UNIT(4), theme.UNIT(4), theme.FONT_SIZE(14))
}); // -------- Components -------->

var PAGE = 'page';
var TYPE = 'type';
var DETAILS = 'details';
var LINK = 'link';
var NAME = 'name';
var EMAIL = 'email';
var COMPANY = 'company';
var URL = 'url';
var STAKEHOLDER_TYPE = 'stakeholderType';
var FORM_NAME = 'contribute';
var My = {
  Container: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Loader: styled(FormLoader)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  Thankyou: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ThankyouStyles),
  ThankyouMessage: styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ThankyouMessageStyles),
  DoneButton: styled(FormButton).attrs({
    type: 'button'
  })(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), DoneButtonStyles),
  Form: styled.form(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  PageField: styled(Field).attrs({
    id: PAGE,
    label: 'Commenting On:'
  })(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  Page: styled(Select).attrs({
    id: PAGE,
    placeholder: 'Select a Page'
  })(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  TypeField: styled(Field).attrs({
    id: TYPE,
    label: 'Your Contribution:'
  })(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  Type: styled(Select).attrs({
    id: TYPE,
    placeholder: 'Contribution Type'
  })(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  DetailsField: styled(Field).attrs({
    id: DETAILS
  })(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  Details: styled(TextArea).attrs({
    id: DETAILS,
    placeholder: 'Details (Required)'
  })(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), TextAreaStyles),
  LinkField: styled(Field).attrs({
    id: LINK
  })(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  Link: styled(Input).attrs({
    id: LINK,
    placeholder: 'Link (if applicable)'
  })(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  NameField: styled(Field).attrs({
    id: NAME,
    label: 'Your Details:'
  })(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  Name: styled(Input).attrs({
    id: NAME,
    placeholder: 'Name (Required)'
  })(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  EmailField: styled(Field).attrs({
    id: EMAIL
  })(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  Email: styled(Input).attrs({
    id: EMAIL,
    placeholder: 'Email'
  })(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  CompanyField: styled(Field).attrs({
    id: COMPANY
  })(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  Company: styled(Input).attrs({
    id: COMPANY,
    placeholder: 'Company'
  })(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  UrlField: styled(Field).attrs({
    id: URL
  })(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  Url: styled(Input).attrs({
    id: URL,
    placeholder: 'Company Website URL'
  })(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  StakeholderTypeField: styled(Field).attrs({
    id: STAKEHOLDER_TYPE
  })(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), FieldStyles),
  StakeholderType: styled(Select).attrs({
    id: STAKEHOLDER_TYPE,
    placeholder: 'Stakeholder Type'
  })(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles),
  Errors: styled(ErrorList)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), ErrorsStyles),
  SubmitButton: styled(FormButton)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), SubmitButtonStyles)
};
export var ContributeForm = function ContributeForm(props) {
  var className = props.className;
  var form = useContributeForm();
  var values = form.values,
      patchValues = form.patchValues;

  var _a = __read(useState(''), 2),
      token = _a[0],
      setToken = _a[1];

  var _b = __read(useState([]), 2),
      errors = _b[0],
      setErrors = _b[1];

  var _c = __read(useState([]), 2),
      errorFields = _c[0],
      setErrorFields = _c[1];

  var page = usePage();
  var items = useLinearNavigation().items;
  var ref = form.useClickOutside();

  var pageOption = function pageOption(item) {
    if (!item) {
      return null;
    }

    var label = filter([item.outlineNumber, item.name]).join('. ');
    return {
      label: label,
      value: item.path,
      depth: item.depth
    };
  };

  var pageOptions = items.map(pageOption);
  var pageDefaultOption = pageOption(items.find(function (item) {
    return item.path === page.path;
  }));

  if (!pageDefaultOption) {
    // if the page is not in the dropdown, just append it to the end
    pageDefaultOption = {
      depth: 0,
      label: "" + page.name,
      value: page.path
    };
    pageOptions.push(pageDefaultOption);
  }

  var typeDefaultOption = {
    value: 'Comment',
    label: 'Comment'
  };
  var typeOptions = [typeDefaultOption, {
    value: 'Expert Suggestion',
    label: 'Expert Suggestion'
  }, {
    value: 'Feedback',
    label: 'Feedback'
  }, {
    value: 'Product or Solution',
    label: 'Product or Solution'
  }, {
    value: 'Research Insight',
    label: 'Research Insight'
  }];
  var stakeholderTypeOptions = [{
    value: 'Academic',
    label: 'Academic'
  }, {
    value: 'Diplomacy',
    label: 'Diplomacy'
  }, {
    value: 'Citizen',
    label: 'Citizen'
  }, {
    value: 'Impact',
    label: 'Impact'
  }];

  var formState = __assign(__assign({}, values), {
    page: values[PAGE] || pageDefaultOption,
    type: values[TYPE] || typeDefaultOption
  });

  var onChange = function onChange(name) {
    return function (value) {
      var _a;

      patchValues((_a = {}, _a[name] = value, _a));
      setErrors([]);
      setErrorFields(without(errorFields, name));
    };
  };

  var onSubmit = function onSubmit(event) {
    return __awaiter(void 0, void 0, void 0, function () {
      var e, ef, data, response;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            event.preventDefault();
            e = [];
            ef = [];

            if (!token) {
              errors.push('Please check the I\'m not a robot checkbox to validate you are human');
            }

            if (trim(formState[NAME]) === '') {
              e.push('Please enter your name.');
              ef.push(NAME);
            }

            if (trim(formState[DETAILS]) === '') {
              e.push('Please describe your contribution in the Details field.');
              ef.push(DETAILS);
            }

            if (trim(formState[EMAIL]) !== '' && !EmailValidator.validate(formState[EMAIL])) {
              e.push('Please check that your email address is VALID');
              ef.push(EMAIL);
            }

            if (trim(formState[LINK]) !== '' && !validUrl.isWebUri(formState[LINK])) {
              e.push('Please provide a VALID URL in the link field');
              ef.push(LINK);
            }

            if (trim(formState[URL]) !== '' && !validUrl.isWebUri(formState[URL])) {
              e.push('Please provide a VALID URL in the Company Website URL field');
              ef.push(URL);
            }

            setErrorFields(ef);
            setErrors(e);

            if (e.length) {
              return [2
              /*return*/
              , false];
            }

            data = __assign(__assign({}, formState), {
              'g-recaptcha-response': token
            });
            form.startSubmit();
            return [4
            /*yield*/
            , onSubmitNetlifyForm(FORM_NAME, page.path, data)];

          case 1:
            response = _a.sent();
            setToken('');
            form.endSubmit();
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  var onCaptchaChange = function onCaptchaChange(token) {
    setToken(token);
  };

  var isSubmitDisabled = !token;
  var hasErrors = !!errors.length;
  var SITE_RECAPTCHA_KEY = useSiteRecaptchaKey();
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, form.isSubmitting && React.createElement(My.Loader, null, "Please wait..."), form.isSubmitted ? React.createElement(My.Thankyou, null, React.createElement(My.ThankyouMessage, null, React.createElement("p", null, "We've received your feedback."), React.createElement("p", null, "Thanks for your contribution!")), React.createElement(My.DoneButton, {
    onClick: function onClick() {
      form.reset();
      form.hide();
    }
  }, "Done")) : React.createElement(My.Form, {
    name: FORM_NAME,
    onSubmit: onSubmit,
    method: "post",
    "data-netlify": "true",
    "data-netlify-recaptcha": "true"
  }, React.createElement("input", {
    type: "hidden",
    name: "form-name",
    value: FORM_NAME
  }), React.createElement(My.PageField, null, React.createElement(My.Page, {
    isClearable: false,
    onChange: onChange(PAGE),
    value: formState[PAGE],
    options: pageOptions
  })), React.createElement(My.TypeField, null, React.createElement(My.Type, {
    isClearable: false,
    onChange: onChange(TYPE),
    value: formState[TYPE],
    placeholder: "Contribution Type",
    options: typeOptions
  })), React.createElement(My.DetailsField, null, React.createElement(My.Details, {
    hasError: includes(errorFields, DETAILS),
    onChange: onChange(DETAILS)
  }, formState[DETAILS] || '')), React.createElement(My.LinkField, null, React.createElement(My.Link, {
    hasError: includes(errorFields, LINK),
    onChange: onChange(LINK),
    value: formState[LINK] || ''
  })), React.createElement(My.NameField, null, React.createElement(My.Name, {
    hasError: includes(errorFields, NAME),
    onChange: onChange(NAME),
    value: formState[NAME] || ''
  })), React.createElement(My.EmailField, null, React.createElement(My.Email, {
    hasError: includes(errorFields, EMAIL),
    onChange: onChange(EMAIL),
    value: formState[EMAIL] || ''
  })), React.createElement(My.CompanyField, null, React.createElement(My.Company, {
    hasError: includes(errorFields, COMPANY),
    onChange: onChange(COMPANY),
    value: formState[COMPANY] || ''
  })), React.createElement(My.UrlField, null, React.createElement(My.Url, {
    hasError: includes(errorFields, URL),
    onChange: onChange(URL),
    value: formState[URL] || ''
  })), React.createElement(My.StakeholderTypeField, null, React.createElement(My.StakeholderType, {
    onChange: onChange(STAKEHOLDER_TYPE),
    options: stakeholderTypeOptions,
    value: formState[STAKEHOLDER_TYPE]
  })), SITE_RECAPTCHA_KEY && React.createElement(ReCAPTCHA, {
    sitekey: SITE_RECAPTCHA_KEY,
    onChange: onCaptchaChange
  }), hasErrors && React.createElement(My.Errors, {
    items: errors
  }, "Sorry, we need a bit more information:"), React.createElement(My.SubmitButton, {
    disabled: isSubmitDisabled
  })));
};
ContributeForm.defaultProps = ContributeFormDefaultProps;
ContributeForm.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39;